<div style="width: 100%; max-height: calc(100% - 220px); overflow: auto;">
  <table mat-table [dataSource]="dataSource" matSort style="width: 100%;">

    <!-- Checkbox Column -->
    <ng-container matColumnDef="select">
      <th mat-header-cell *matHeaderCellDef>
        <mat-checkbox (change)="$event ? masterToggle() : null" [checked]="selection.hasValue() && isAllSelected()"
          [indeterminate]="selection.hasValue() && !isAllSelected()">
        </mat-checkbox>
      </th>
      <td mat-cell *matCellDef="let row">
        <mat-checkbox (click)="$event.stopPropagation()" (change)="$event ? selection.toggle(row) : null"
          [checked]="selection.isSelected(row)">
        </mat-checkbox>
      </td>
    </ng-container>

    <!-- year Column -->
    <ng-container matColumnDef="year">
      <th class="header" mat-header-cell *matHeaderCellDef>
        <div mat-sort-header>{{ 'label.year' | translate }}</div>
      </th>
      <td mat-cell *matCellDef="let element">
        <span> {{ element?.year }}</span>
      </td>
    </ng-container>

    <!-- month Column -->
    <ng-container matColumnDef="month">
      <th class="header" mat-header-cell *matHeaderCellDef>
        <div mat-sort-header>{{ 'label.month' | translate }}</div>
      </th>
      <td mat-cell *matCellDef="let element">
        <span *ngIf="!(element?.billingType == BillingType.Concession)"> {{ ('label.month-' + element?.month) |
          translate}}</span>
        <span *ngIf="element?.billingType == BillingType.Concession"> {{ ('label.quarter-' + element?.quarter) |
          translate}}</span>
      </td>
    </ng-container>

    <!-- site Column -->
    <ng-container matColumnDef="site">
      <th class="header" mat-header-cell *matHeaderCellDef>
        <div mat-sort-header>{{ 'label.site' | translate }}</div>
      </th>
      <td mat-cell *matCellDef="let element">
        <span> {{ element?.site?.name }}</span>
      </td>
    </ng-container>

    <!-- company Column -->
    <ng-container matColumnDef="company">
      <th class="header" mat-header-cell *matHeaderCellDef>
        <div mat-sort-header>{{ 'label.company' | translate }}</div>
      </th>
      <td mat-cell *matCellDef="let element">
        <span> {{ element?.company?.name }}</span>
      </td>
    </ng-container>

    <!-- billingType Column -->
    <ng-container matColumnDef="billingType">
      <th class="header" mat-header-cell *matHeaderCellDef>
        <div mat-sort-header>{{ 'label.billing-type' | translate }}</div>
      </th>
      <td mat-cell *matCellDef="let element">
        <span> {{ ('label.billing-type-' + element.billingType ) | translate }}</span>
      </td>
    </ng-container>

    <!-- date Column -->
    <ng-container matColumnDef="date">
      <th class="header" mat-header-cell *matHeaderCellDef>
        <div mat-sort-header>{{ 'label.date' | translate }}</div>
      </th>
      <td mat-cell *matCellDef="let element">
        <span> {{ element.date | date : 'dd/MM/yy'}}</span>
      </td>
    </ng-container>

    <!-- action Column -->
    <!-- <ng-container matColumnDef="action">
    <th class="header" mat-header-cell *matHeaderCellDef>
      <div mat-sort-header> </div>
    </th>
    <td mat-cell *matCellDef="let element">
      <button mat-raised-button color="primary" (click)="onEdit(element)" *ngIf="uiService.isSupervision()">
        <mat-icon>edit</mat-icon>
        {{ 'button.edit' | translate }}
      </button>
      <button mat-raised-button color="warn" (click)="onReportAnError(element)" *ngIf="uiService.isDeclaration()">
        <mat-icon>info</mat-icon>
        {{ 'button.report-an-error' | translate }}
      </button>
    </td>
  </ng-container> -->

    <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;" [ngClass]="{'highlight': selectedRowID == row.id}"
      (click)="selection.toggle(row)"></tr>
  </table>

</div>
<mat-paginator class="m-5 mat-elevation-z2" [pageSizeOptions]="pageSizeOptions" showFirstLastButtons>
</mat-paginator>

<div style="display: flex;justify-content: flex-end;">
  <button mat-raised-button color="primary" [disabled]="selection.isEmpty()" (click)="onGenerate()"
    style="margin-top: 20px; margin-right: 20px;">
    <mat-icon>credit_card</mat-icon> {{ 'button.bill' | translate }}
  </button>
</div>